import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MatchAssetSchema = withDefaults({
  type: 'match-asset',
  fields: [
    {
      kind: 'attribute',
      name: 'bucket',
    },
    {
      kind: 'attribute',
      name: 'contentType',
    },
    {
      kind: 'attribute',
      name: 'downloadUrls',
    },
    {
      kind: 'attribute',
      name: 'filename',
    },
    {
      kind: 'attribute',
      name: 'fullPath',
    },
    {
      kind: 'attribute',
      name: 'raw',
    },
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'path',
    },
    {
      kind: 'attribute',
      name: 'size',
    },
    {
      kind: 'attribute',
      name: 'slug',
    },
    {
      kind: 'attribute',
      name: 'tags',
    },
    {
      kind: 'attribute',
      name: 'uuid',
    },
    {
      kind: 'attribute',
      name: 'signedUrl',
    },
    {
      kind: 'attribute',
      name: 'classification',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'attachmentDeletedAt',
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'assetSummary',
      type: 'asset-summary',
      options: {
        async: false,
        inverse: 'digitalAsset',
        polymorphic: true,
        as: 'digital-asset',
      },
    },
    {
      kind: 'hasMany',
      name: 'accountTransactions',
      type: 'account-transaction',
      options: {
        async: false,
        inverse: 'matchAssets',
      },
    },
  ],
});

export default MatchAssetSchema;
